@if (loading()) {
	<div class="flex grow items-center justify-center" data-cy="symbol-messages-loading">
		<ui-loading message="در حال دریافت پیام‌ها ..." />
	</div>
} @else if (hasError()) {
	<ui-empty-state
		class="grow items-center"
		data-cy="symbol-messages-error"
		variant="error"
		description=""
		iconName="alert-box"
		title="دریافت پیام‌ها با خطا مواجه شد"
		primaryButtonLabel="تلاش مجدد"
		[showButton]="true"
		(primaryClicked)="onRetry()" />
} @else if (isEmpty()) {
	<ui-empty-state
		class="grow"
		data-cy="symbol-messages-empty"
		variant="info"
		description=""
		title="پیامی وجود ندارد" />
} @else {
	<!--
		No scroll container of its own: the symbol-detail page already scrolls, and a second
		unbounded one here would leave the sticky day headers nothing to stick against.
	-->
	<div data-cy="symbol-messages-list">
		@for (group of dayGroups(); track group.key) {
			<div
				class="sticky top-0 z-1 flex items-center justify-center gap-1 bg-gray-100 py-1 text-xs text-gray-600"
				data-cy="symbol-messages-day">
				<ui-icon width="18" height="18" aria-hidden="true" [iconName]="IconName.Calendar" />
				<span class="tabular-nums">تاریخ: {{ group.date }}</span>
			</div>

			<div class="flex flex-col gap-1.5 py-1.5">
				@for (message of group.messages; track message.id) {
					<app-symbol-message-card [message]="message" />
				}
			</div>
		}
	</div>
}
